import { RootState } from '@cp/src/store';
import { formatDate } from '@cp/src/utils/commonUtils';
import { ModalDialog, Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { IPanExpandedModal } from '../../interface';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { useEffect } from 'react';

const PanExpandedModal = (props: IPanExpandedModal) => {
  const { showExpandImageModal, toggleImageExpandModal } = props;
  const selectedPanApprovalItem = useSelector(
    (state: RootState) => state.approvals.selectedPanApprovalItem
  );

  const {
    agentName,
    dateOfBirth = '',
    panNumber,
    originalPanDocumentUri,
    originalSelfieDocumentUri
  } = selectedPanApprovalItem?.data || {};

  useEffect(() => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_APPROVAL_PAN_EXPANDED_VIEW_OPENED, {
      approvalItem: selectedPanApprovalItem?.referenceId
    });
  }, []);

  return (
    <ModalDialog
      dialogClass="!w-auto !p-4 !pt-3"
      contentClasses="!mt-2"
      open={showExpandImageModal}
      onClose={toggleImageExpandModal}
      header={agentName}
      customHeader={
        <div className="flex items-center">
          <Typography variant="h2" color="var(--navi-color-gray-c2)">
            {agentName}
          </Typography>
          <Typography variant="h3" className="ml-1" color="var(--navi-color-gray-c3)">
            ( DOB: {formatDate(dateOfBirth, { year: 'numeric' })} | PAN: {panNumber} )
          </Typography>
        </div>
      }
    >
      <div className="flex gap-6">
        <img
          src={originalSelfieDocumentUri}
          alt="id-image"
          className={styles.expandedSelfieImage}
        />
        <img src={originalPanDocumentUri} alt="id-image" className={styles.expandedPanImage} />
      </div>
    </ModalDialog>
  );
};

export default PanExpandedModal;
